import { country, userRole } from 'src/common/enums/enums';
import { Enum } from 'src/models/Enum';

const SIMPLE_USER_COUNTRY_CODES = [country.HR, country.RO, country.SI];

export const filterCountries = (
    countryEnum: Enum,
    currentUserRole: string
): Enum => {
    if (currentUserRole !== userRole.SIMPLE_USER) {
        return countryEnum;
    }

    return {
        data: countryEnum.data.filter(({ code }) =>
            SIMPLE_USER_COUNTRY_CODES.includes(code)
        )
    };
};
